import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type AddCourseDTO = {
    name:string;
    description:string;
    part:string | number | null;
    InstructorId:string | null;
    img_url:string;
    num_hours:string;
    actualPrice_egp:string;
    actualPrice_usd:string;
    preview_video:string;
    isTrending:boolean;
    allowDemo?:boolean;
};

type CourseResponse  = AddCourseDTO & {
    id:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;

export const AddNewCourse = (data: AddCourseDTO): Promise<CourseResponse> => {
    return axios.post("/course/create", data)
        .then(response => response.data as CourseResponse);
};